import "dayjs/locale/ko";

// "오전 12 : 01" 또는 "오후 01 : 22" -> "HH:mm:ss"
export const parseTo24Hour = (timeString: string): string => {
  if (!timeString) return ""; // undefined/null일 때 빈 문자열 반환

  const [ampm, hh, mm] = timeString.split(/[: ]/).filter(Boolean);
  // ["오전", "12", "01"] or ["오후", "01", "22"]

  let hour = Number(hh);
  const minute = String(mm).padStart(2, "0");

  if (ampm === "오전") {
    if (hour === 12) hour = 0; // 오전 12시는 00시
  } else if (ampm === "오후") {
    if (hour !== 12) hour += 12; // 오후 + 12시
  }

  return `${String(hour).padStart(2, "0")}:${minute}:00`;
};

// "13:22:00" -> "오후 01 : 22"
export const formatToAmPm = (time: string): string => {
  if (!time) return ""; // undefined/null일 때 빈 문자열 반환
  const [hh, mm] = time.split(":");
  let hour = Number(hh);
  const minute = String(mm).padStart(2, "0");
  let period = "오전";

  if (hour === 0) {
    hour = 12; // 0시는 오전 12시
  } else if (hour === 12) {
    period = "오후"; // 12시는 오후 12시
  } else if (hour > 12) {
    period = "오후";
    hour -= 12;
  }

  return `${period} ${String(hour).padStart(2, "0")} : ${minute}`;
};

// hour: "02", min: "15", dayN: "오후" → "14:15:00"
export const convertTo24HourFormat = (
  hour: string,
  min: string,
  dayN: string
): string => {
  let h = parseInt(hour, 10);

  if (dayN === "오전") {
    if (h === 12) h = 0; // 오전 12시는 00시
  } else if (dayN === "오후") {
    if (h !== 12) h += 12; // 오후인데 12시 아니면 +12
  }

  return `${String(h).padStart(2, "0")}:${min}:00`;
};

// 오전 00 : 00 => 00:00
export const formatTimeForPayload = (timeStr: string) => {
  if (!timeStr) return ""; // undefined/null일 때 빈 문자열 반환

  const [ampm, hh, mm] = timeStr.split(/[: ]/).filter(Boolean);

  let hour = Number(hh);
  const minute = String(mm).padStart(2, "0");

  if (ampm === "오전") {
    if (hour === 12) hour = 0; // 오전 12시는 00시
  } else if (ampm === "오후") {
    if (hour !== 12) hour += 12; // 오후 + 12시
  }

  return `${String(hour).padStart(2, "0")}:${minute}`;
};

export const formatDateFromYYYYMMDD = (d?: string | null) => {
  if (!d) return null;
  // 이미 2025-11-03 형식이면 그대로 반환
  if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d;
  // YYYYMMDD -> YYYY-MM-DD
  if (/^\d{8}$/.test(d)) {
    return `${d.slice(0, 4)}-${d.slice(4, 6)}-${d.slice(6, 8)}`;
  }
  // fallback: 시도해보고 실패하면 null
  try {
    const maybe = new Date(d);
    return isNaN(maybe.getTime()) ? null : maybe.toISOString().slice(0, 10);
  } catch {
    return null;
  }
};
